import styled from "styled-components";

const PageContainer: React.FC<any> = ({ children }: any) => {
   return <Container>{children}</Container>;
};

const Container = styled.main`
   background: #f5fffa;
   font-family: "Inter";
`;

export { PageContainer };
